export default __webpack_public_path__ + "static/media/solr-book.560e1df6.png";